import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewAuthentication } = appStoreLenses

export default viewAuthentication
